import React from 'react';

import './App.css';
import './AppMobile.css';

import './Interceptors';

import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api';

import { Badge } from 'primereact/badge';
import { OverlayPanel } from 'primereact/overlaypanel';
import iconMenu from './img/menu.svg'
import { Dialog } from 'primereact/dialog';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import CryptoJS from 'crypto-js';
import UsuarioService from './services/UsuarioService';
import { hideProcess, showProcess } from './utils/utils';

class Template2 extends React.Component {

    constructor(props) {
        super(props);

        this.state = {          
          usuario: {}
        }
    }
    
    componentDidMount() {
        addLocale("pt", {    
                    "startsWith":"Começa com",
                    "contains":"Contém",
                    "notContains":"Não contém",
                    "endsWith":"Termina com",
                    "equals":"Igual",
                    "notEquals":"Diferente",
                    "noFilter":"Sem filtro",
                    "filter": "Filtro",
                    "lt":"Menor que",
                    "lte":"Menor que ou igual a",
                    "gt":"Maior que",
                    "gte":"Maior que ou igual a",
                    "dateIs":"Data é",
                    "dateIsNot":"Data não é",
                    "dateBefore":"Date é anterior",
                    "dateAfter":"Data é posterior",
                    "custom":"Customizado",
                    "clear":"Limpar",
                    "close":"Fechar",
                    "apply":"Aplicar",
                    "matchAll":"Match All",
                    "matchAny":"Match Any",
                    "addRule":"Adicionar Regra",
                    "removeRule":"Remover Regra",    
                    "accept":"Sim",
                    "reject":"Não",
                    "choose":"Escolha",
                    "upload":"Upload",
                    "cancel":"Cancelar",
                    "completed": "Concluído",
                    "pending": "Pendente",
                    "fileSizeTypes": ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
                    "dayNames": ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
                    "dayNamesShort": ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
                    "dayNamesMin": ["Do", "Se", "Te", "Qa", "Qi", "Sx", "Sa"],
                    "monthNames": ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
                    "monthNamesShort": ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
                    "chooseYear": "Escolha Ano",
                    "chooseMonth": "Escolha Mês",
                    "chooseDate": "Escolha Data",
                    "prevDecade": "Década Anterior",
                    "nextDecade": "Década Seguinte",
                    "prevYear": "Ano Anterior",
                    "nextYear": "Ano Seguinte",
                    "prevMonth": "Mês Anterior",
                    "nextMonth": "Mês Seguinte",
                    "prevHour": "Hora Anterior",
                    "nextHour": "Hora Seguinte",
                    "prevMinute": "Minuto Anterior",
                    "nextMinute": "Minuto Seguinte",
                    "prevSecond": "Segundo Anterior",
                    "nextSecond": "Segundo Seguinte",
                    "am": "am",
                    "pm": "pm",
                    "today": "Hoje",
                    "now": "Agora",
                    "weekHeader": "Sem",
                    "firstDayOfWeek": 0,
                    "showMonthAfterYear": false,
                    "dateFormat": "dd/mm/yy",
                    "weak": "Fraco",
                    "medium": "Médio",
                    "strong": "Forte",
                    "passwordPrompt": "Digite uma senha",
                    "emptyFilterMessage":"Nenhum resultado encontrado",
                    "searchMessage": "{0} resultados disponíveis",
                    "selectionMessage": "{0} itens selecionados",
                    "emptySelectionMessage": "Nenhum item selecionado",
                    "emptySearchMessage": "Nenhum resultado encontrado",
                    "emptyMessage":"Nenhuma opção disponível",
                    "aria": {
                          "trueLabel": "Verdadeiro",
                          "falseLabel": "Falso",
                          "nullLabel": "Não selecionado",
                          "star": "1 estrela",
                          "stars": "{star} estrelas",
                          "selectAll": "Todos itens selecionados",
                          "unselectAll": "Nenhum item selecionado",
                          "close": "Fechar",
                          "previous": "Anterior",
                          "next": "Seguinte",
                          "navigation": "Navegação",
                          "scrollTop": "Rolar para Topo",
                          "moveTop": "Mover para Topo",
                          "moveUp": "Mover para Cima",
                          "moveDown": "Mover para Baixo",
                          "moveBottom": "Mover para Final",
                          "moveToTarget": "Mover para Alvo",
                          "moveToSource": "Mover para Fonte",
                          "moveAllToTarget": "Mover Todos para Alvo",
                          "moveAllToSource": "Mover Todos para Fonte",
                          "pageLabel": "Página {page}",
                          "firstPageLabel": "Primeira Página",
                          "lastPageLabel": "Última Página",
                          "nextPageLabel": "Página Seguinte",
                          "previousPageLabel": "Página Anterior",
                          "rowsPerPageLabel": "Linhas por página",
                          "jumpToPageDropdownLabel": "Pular para Menu da Página",
                          "jumpToPageInputLabel": "Pular para Campo da Página",
                          "selectRow": "Linha Selecionada",
                          "unselectRow": "Linha Não Selecionada",
                          "expandRow": "Linha Expandida",
                          "collapseRow": "Linha Recolhida",
                          "showFilterMenu": "Mostrar Menu de Filtro",
                          "hideFilterMenu": "Esconder Menu de Filtro",
                          "filterOperator": "Operador de Filtro",
                          "filterConstraint": "Restrição de Filtro",
                          "editRow": "Editar Linha",
                          "saveEdit": "Salvar Editar",
                          "cancelEdit": "Cancelar Editar",
                          "listView": "Exibição em Lista",
                          "gridView": "Exibição em Grade",
                          "slide": "Deslizar",
                          "slideNumber": "{slideNumber}",
                          "zoomImage": "Ampliar Imagem",
                          "zoomIn": "Mais Zoom",
                          "zoomOut": "Menos Zoom",
                          "rotateRight": "Girar à Direita",
                          "rotateLeft": "Girar à Esquerda"
                      
                  }
                });

        locale("pt");
        
    }

    logout = () => {
        if (window.confirm("Deseja finalizar sua sessão?")){
            localStorage.clear();
            window.location.href = "/";
        }
    }

    refreshState = () => {
        this.setState({})
    }

    getCarrinhoItens = () => {
        try{

            var carrinho = JSON.parse(localStorage.carrinho);
            
            return carrinho.itens.length;

        }catch(e){
            return 0
        }
        
    }

    alterKey = async (e) => {
        e.preventDefault();


        try{
            if (CryptoJS.MD5(this.state.senhaAtual).toString() !== JSON.parse(localStorage.getItem("usuario"))['senha']){
                alert('Senha inválida.');
                return
            }

            if (this.state.novaSenha !== this.state.repetirSenha){
                alert('Repetição incorreta.');
                this.setState({repetirSenha: ""});
                return
            }

            showProcess();

            var response = await UsuarioService.alterKey(JSON.parse(localStorage.getItem("usuario"))['id'], CryptoJS.MD5(this.state.senhaAtual).toString(), CryptoJS.MD5(this.state.novaSenha).toString());
            
            if (response.data.status === "sucess"){
                localStorage.setItem("usuario", JSON.stringify(response.data.object));
                alert("Senha alterada.");
                this.setState({showAlterarSenha: false, senhaAtual: undefined, novaSenha: undefined, repetirSenha: undefined})
            }else{
                alert(response.data.message);
            }

        }catch(e){

        }
        
        hideProcess();
    }

    render() {
        return(
          <div className="App">
            <div  className="App-header">
                <img src={require("./img/coroa.png")} style={{width: '50px', cursor: 'pointer'}} className='app-logo' onClick={() => window.location.href = "/loja"}/>
                
                <a href='/carrinho'>
                    <i className="pi icon-carrinho overlay-badge" style={{ fontSize: '2rem', width: '50px', height: '50px', float: 'right', position: 'relative', cursor: 'pointer'}}>
                        <Badge style={{color: '#ffffff'}} value={this.getCarrinhoItens()}></Badge>
                    </i>
                </a>
                
                <img src={iconMenu} className='App-btn-menu' style={{width: '40px', float: 'right', marginRight: '30px', cursor: 'pointer'}} onClick={(e) => this.op.toggle(e)} />
                <OverlayPanel ref={ref => this.op = ref} className='app-overlay-menu' >
                    <div style={{padding: '5px'}}>
                        <table>
                            <tr>
                                <td rowSpan={2} style={{paddingRight: '5px'}}><div className='app-letra-usuario' >{JSON.parse(localStorage.getItem("usuario")).cliente.nome.substring(0,1)}</div></td>
                                <td style={{paddingRight: '20px'}}>{JSON.parse(localStorage.getItem("usuario")).cliente.nome}</td>
                            </tr>
                            <tr>
                                <td>
                                    <a href='/perfil'><div>Perfil ></div></a>
                                </td>
                            </tr>
                        </table>
                        <hr style={{margin: '0px'}} />
                    </div>                    
                    
                    <a href='/loja'><div>Loja</div></a>
                    <a href='/pedidos'><div>Meus Pedidos</div></a>

                    <div>
                        <hr style={{margin: '0px'}} />
                    </div>
                    
                    <a onClick={() => this.setState({showAlterarSenha: true})}><div>Alterar Senha</div></a>
                    
                    <a onClick={() => this.logout()}><div>Sair</div></a>
                </OverlayPanel>
                
            </div>
            <div className="App-content">
              
                {this.props.children}
              
            </div>
            {this.state.showAlterarSenha &&
                <Dialog header={"ALTERAR SENHA"} visible={true} onHide={() => this.setState({showAlterarSenha: false, senhaAtual: undefined, novaSenha: undefined, repetirSenha: undefined})}>
                    <form onSubmit={(e) => this.alterKey(e)}>
                        <div className='App-field'>
                            <span className='App-label'>Senha Atual</span>
                            <Password value={this.state.senhaAtual} onChange={(e) => this.setState({senhaAtual: e.target.value})} inputStyle={{width: '300px'}} feedback={false} />
                        </div>
                        <div className='App-field'>
                            <span className='App-label'>Nova Senha</span>
                            <Password value={this.state.novaSenha} onChange={(e) => this.setState({novaSenha: e.target.value})} inputStyle={{width: '300px'}} />
                        </div>
                        <div className='App-field'>
                            <span className='App-label'>Repetir Senha</span>
                            <Password value={this.state.repetirSenha} onChange={(e) => this.setState({repetirSenha: e.target.value})} inputStyle={{width: '300px'}} feedback={false} />
                        </div>

                        <Button label='CONFIRMAR' className='app-background-gold' style={{padding: '10px', border: '2px solid #DAA520', marginTop: '10px', width: '100%'}} />
                    </form>
                </Dialog>
            }
          </div>
        )
    }

}

export default Template2;